import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-medium text-white" }
const _hoisted_5 = { class: "flex flex-wrap gap-2" }
const _hoisted_6 = { class: "flex justify-end gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = { class: "text-white font-bold text-lg" }
const _hoisted_12 = { class: "flex flex-col items-end gap-2" }
const _hoisted_13 = { class: "flex items-center gap-1" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex flex-wrap gap-1" }
const _hoisted_17 = { class: "flex items-center justify-between pt-2" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_20 = {
  key: 0,
  class: "grid grid-cols-2 gap-6 py-4"
}
const _hoisted_21 = { class: "grid gap-2 col-span-full" }
const _hoisted_22 = { class: "grid gap-2 col-span-full" }
const _hoisted_23 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_24 = { class: "grid gap-2 col-span-full" }

import { ref, computed, onMounted, watch } from 'vue'
import {
  ArrowsUpDownIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import {
  Dialog,
  DialogScrollContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Badge } from '@/components/ui/badge'
import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { usePaymentPlan } from '@/composables/usePaymentPlan'
import { PaymentPlan } from '@/interfaces/PaymentPlan'
import { CircleHelp, Loader2, Package as PackageIcon } from 'lucide-vue-next'
import { useToast } from '@/components/ui/toast'
import { TagsInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText } from '@/components/ui/tags-input'
import { ComboboxAnchor, ComboboxContent, ComboboxInput, ComboboxPortal, ComboboxRoot } from 'radix-vue'
import TagsInputInput from '@/components/ui/tags-input/TagsInputInput.vue'
import { CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command'
import { AcceptableInputValue } from 'radix-vue/dist/TagsInput/TagsInputRoot'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import MultipleFilesUpload from '@/components/ui/upload/MultipleFilesUpload.vue'
import { CreatePackageDTO, GetAllPackagesParams, UpdatePackageDTO, usePackage } from '@/composables/usePackage'
import { Package } from '@/interfaces/packages/Package'
import { PackageStatatusEnum, PackageStatusLabels } from '@/enums/packages/PackageStatusEnum'
import StatusBadge from '@/components/ui/badge/StatusBadge.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagePackagesView',
  setup(__props) {

const { toast } = useToast()
const { create, update, getAll, destroy, getById } = usePackage()
const { getAll: getAllPaymentPlans } = usePaymentPlan()
const paymentPlans = ref<IPagination<PaymentPlan>>()
// Table Configuration
const tableHeaders = [
  { key: 'name', label: 'Nome', sortable: false },
  { key: 'plans', label: 'Planos de pagamento', sortable: false },
  { key: 'status', label: 'Status', sortable: false },
  { key: 'actions', label: '', class: 'w-32' },
]
const isSaving = ref(false)
const perPage = ref('10')
const previews = ref<string[]>([])

// Filters
const filteredPaymentPlans = computed(() => paymentPlans.value?.data.filter(i => !packForm.value.paymentPlanIds?.includes(String(i.id))))
const searchPaymentPlan = ref('')
const isPaymentPlanComboboxOpen = ref(false)
// Packages data (empty for demo)
const packs = ref<IPagination<Package>>()
const paymentPlanNames = ref<string[]>([])
// Dialog and Form
const isPackageDialogOpen = ref(false)
const isPackageDialogLoading = ref(false)
const editingPackage = ref<Package | null>(null)
const packForm = ref<Partial<CreatePackageDTO | UpdatePackageDTO>>({
  name: '',
  paymentPlanIds: [],
  status: PackageStatatusEnum.ACTIVE,
  media: []
})
const deletingPackage = ref<number>()
const isDeletePackageDialogOpen = ref(false)
const isDeletingPackage = ref(false)

// Actions
const openNewPackageDialog = () => {
  previews.value = []
  editingPackage.value = null
  packForm.value = {
    name: '',
    paymentPlanIds: [],
    status: PackageStatatusEnum.ACTIVE,
    media: []
  }
  paymentPlanNames.value = []
  searchPaymentPlan.value = ''
  isPaymentPlanComboboxOpen.value = false
  isPackageDialogOpen.value = true
}

const closePackageDialog = () => {
  isPackageDialogOpen.value = false
}

const editPackage = async (pack: Package) => {
  isPackageDialogOpen.value = true
  isPackageDialogLoading.value = true
  isPaymentPlanComboboxOpen.value = false
  searchPaymentPlan.value = ''
  editingPackage.value = await getById(pack.id)
  previews.value = editingPackage.value.media?.map(media => media.source) ?? []
  isPackageDialogLoading.value = false
  packForm.value = {
    name: pack.name,
    status: pack.status,
    paymentPlanIds: ((pack.paymentPlans?.map(plan => String(plan.id)) ?? []) as unknown as AcceptableInputValue[]),
  }
  paymentPlanNames.value = pack.paymentPlans?.map(plan => plan.name) ?? []
}

const deletePackage = (pack: any) => {
  isDeletePackageDialogOpen.value = true
  deletingPackage.value = pack.id
}

const sortBy = (key: string) => {
  // Implement sorting logic
}

const save = async () => {
  isSaving.value = true

  try {
    let payload = { ...packForm.value }

    if (!editingPackage.value) {
      const pack = await create(payload as CreatePackageDTO)
      toast({
        title: 'pack criado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      packs.value = await getAll()
    } else {
      if (editingPackage.value.media.length !== previews.value.length) {
        const deletedMedia = editingPackage.value.media?.filter(media => !previews.value.includes(media.source));
        (payload as UpdatePackageDTO).deleteMediaIds = deletedMedia.map(media => media.id)
      }
      await update(editingPackage.value.id, payload as UpdatePackageDTO)
      toast({
        title: 'pack editado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })

      const _paymentPlans = paymentPlans.value?.data.filter(plan => payload.paymentPlanIds?.includes(String(plan.id))) ?? []
      const index = packs.value!.data.findIndex(pack => pack.id == editingPackage.value!.id)
      
      if (index !== -1 && index !== null) {
        packs.value!.data[index] = { 
          ...packs.value!.data[index], 
          ...packForm.value,
          paymentPlans: _paymentPlans,
        } as Package
      }
    }

    isPackageDialogOpen.value = false
  } finally {
    isSaving.value = false
  }
}

function reloadAndGetAll(params: GetAllPackagesParams) {
  packs.value = undefined
  getAll(params)
    .then(data => packs.value = data)
}

watch(() => perPage.value, () => {
  reloadAndGetAll({ perPage: perPage.value })
})

watch(() => isPackageDialogOpen.value, () => {
  if (!paymentPlans.value) {
    getAllPaymentPlans({ perPage: '100' })
      .then((data) => paymentPlans.value = data)
  }
})

onMounted(() => {
  getAll()
    .then((data) => packs.value = data)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(PageTitle, null, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode(" Gerencie seus packs ")
            ])),
            _: 1
          }),
          _createVNode(PageDescription, null, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode(" Gerencie e personalize seus pacotes com facilidade. ")
            ])),
            _: 1
          })
        ]),
        _createVNode(RegisterButton, { onClick: openNewPackageDialog }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("Cadastrar pack")
          ])),
          _: 1
        })
      ]),
      _createVNode(TableContainer, null, {
        default: _withCtx(() => [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mb-6 flex items-center justify-between" }, [
            _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Packs registrados"),
            _createElementVNode("div", { class: "flex items-center gap-4" })
          ], -1)),
          _createVNode(Table, { class: "hidden md:block" }, {
            default: _withCtx(() => [
              _createVNode(TableHeader, null, {
                default: _withCtx(() => [
                  _createVNode(TableRow, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                        return _createVNode(TableHead, {
                          key: header.key,
                          class: _normalizeClass(header.class)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(header.label) + " ", 1),
                              (header.sortable)
                                ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                    key: 0,
                                    class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                    onClick: ($event: any) => (sortBy(header.key))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(TableBody, null, {
                default: _withCtx(() => [
                  (packs.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (packs.value.data.length === 0)
                          ? (_openBlock(), _createBlock(TableFallback, {
                              key: 0,
                              colspan: tableHeaders.length,
                              icon: _unref(PackageIcon),
                              title: "Nenhum pack encontrado",
                              description: `Clique em 'Cadastrar pack' para começar`
                            }, null, 8, ["colspan", "icon"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packs.value.data, (pack) => {
                          return (_openBlock(), _createBlock(TableRow, {
                            key: pack.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(pack.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pack.paymentPlans, (plan) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: plan.id,
                                        variant: "default"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(plan.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(StatusBadge, {
                                    status: pack.status
                                  }, null, 8, ["status"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      onClick: ($event: any) => (editPackage(pack))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "hover:text-red-400",
                                      onClick: ($event: any) => (deletePackage(pack))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock(TableRowSkeleton, {
                        key: 1,
                        columns: tableHeaders.length
                      }, null, 8, ["columns"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (packs.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (packs.value.data.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(packs.value.data, (pack) => {
                      return (_openBlock(), _createBlock(MobileCard, {
                        key: pack.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Pack", -1)),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(pack.name), 1)
                              ])
                            ])
                          ])
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (editPackage(pack)),
                                class: "text-zinc-400 hover:text-white p-1"
                              }, [
                                _createVNode(_unref(PencilIcon), { class: "size-5" })
                              ], 8, _hoisted_14),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (deletePackage(pack)),
                                class: "text-zinc-400 hover:text-red-400 p-1"
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "size-5" })
                              ], 8, _hoisted_15)
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          _createVNode(MobileDataLabel, { label: "Planos de pagamento" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pack.paymentPlans, (plan) => {
                                  return (_openBlock(), _createBlock(_unref(Badge), {
                                    key: plan.id,
                                    variant: "default",
                                    class: "text-xs"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(plan.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Status", -1)),
                              _createVNode(StatusBadge, {
                                status: pack.status
                              }, null, 8, ["status"])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_unref(PackageIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                      _cache[19] || (_cache[19] = _createTextVNode(" Nenhum pack encontrado "))
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createVNode(Pagination, {
            "onUpdate:page": _cache[0] || (_cache[0] = (page) => reloadAndGetAll({ page })),
            "per-page": perPage.value,
            "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event)),
            data: packs.value?.pagination
          }, null, 8, ["per-page", "data"])
        ]),
        _: 1
      })
    ]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeletePackageDialogOpen.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isDeletePackageDialogOpen).value = $event)),
      loading: isDeletingPackage.value,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => {isDeletingPackage.value = true; _unref(destroy)(deletingPackage.value!).then(() => {
    _unref(toast)({
      title: 'pack excluído com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })
    isDeletingPackage.value = false
    isDeletePackageDialogOpen.value = false
    const index = packs.value?.data.findIndex(pack => pack.id == deletingPackage.value)
    if (index !== -1) packs.value?.data.splice(index!, 1)
  })})
    }, null, 8, ["open", "loading"]),
    _createVNode(_unref(Dialog), {
      open: isPackageDialogOpen.value,
      "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((isPackageDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-2xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editingPackage.value ? 'Editar pack' : 'Novo pack'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode(" Configure as informações do pack e selecione os planos de pagamento. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!isPackageDialogLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode("Nome do pack "),
                        _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(Input), {
                      modelValue: packForm.value.name,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((packForm.value.name) = $event)),
                      placeholder: "Ex: Pack especial"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("Plano "),
                        _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                      ])),
                      _: 1
                    }),
                    (filteredPaymentPlans.value)
                      ? (_openBlock(), _createBlock(_unref(TagsInput), {
                          key: 0,
                          class: "px-0 gap-0 w-full",
                          "model-value": paymentPlanNames.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlanNames.value, (name, index) => {
                                return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                  key: index,
                                  value: name
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(TagsInputItemText)),
                                    _createVNode(_unref(TagsInputItemDelete), {
                                      onClick: ($event: any) => {packForm.value.paymentPlanIds?.splice(index, 1); paymentPlanNames.value.splice(index, 1)}
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _createVNode(_unref(ComboboxRoot), {
                              modelValue: paymentPlanNames.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((paymentPlanNames).value = $event)),
                              open: isPaymentPlanComboboxOpen.value,
                              "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((isPaymentPlanComboboxOpen).value = $event)),
                              "search-term": searchPaymentPlan.value,
                              "onUpdate:searchTerm": _cache[9] || (_cache[9] = ($event: any) => ((searchPaymentPlan).value = $event)),
                              class: "w-full"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ComboboxInput), {
                                      placeholder: "Plano premium...",
                                      "as-child": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(TagsInputInput, {
                                          onFocus: _cache[5] || (_cache[5] = ($event: any) => (isPaymentPlanComboboxOpen.value = true)),
                                          class: _normalizeClass(["w-full px-3", (packForm.value.paymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                          onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                        }, null, 8, ["class"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ComboboxPortal), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ComboboxContent), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(CommandList), {
                                          position: "popper",
                                          class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(CommandEmpty), null, {
                                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                _createTextVNode("Nenhum plano encontrado")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_unref(CommandGroup), null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPaymentPlans.value, (paymentPlan) => {
                                                  return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                    key: paymentPlan.id,
                                                    value: String(paymentPlan.name),
                                                    onSelect: _withModifiers((ev) => {
                          if (typeof ev.detail.value === 'string') {
                            searchPaymentPlan.value = ''
                            const paymentPlan = filteredPaymentPlans.value?.find(plan => plan.name == ev.detail.value)
                            packForm.value.paymentPlanIds?.push(String(paymentPlan!.id))
                            paymentPlanNames.value.push(paymentPlan!.name)
                          }
        
                          if (filteredPaymentPlans.value?.length === 0) {
                            isPaymentPlanComboboxOpen.value = false
                          }
                        }, ["prevent"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(paymentPlan.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value", "onSelect"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "open", "search-term"])
                          ]),
                          _: 1
                        }, 8, ["model-value"]))
                      : _createCommentVNode("", true),
                    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Você pode selecionar mais de 1 plano", -1))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createTextVNode("Status "),
                        _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(Select), {
                      modelValue: packForm.value.status,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((packForm.value.status) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectTrigger), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectValue), { placeholder: "Selecione o status" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(SelectContent), null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PackageStatatusEnum), (status) => {
                              return (_openBlock(), _createBlock(_unref(SelectItem), { value: status }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(PackageStatusLabels)[status]), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 256))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode(MultipleFilesUpload, {
                    label: "Mídias",
                    required: true,
                    previews: previews.value,
                    "onUpdate:previews": _cache[11] || (_cache[11] = ($event: any) => ((previews).value = $event)),
                    modelValue: packForm.value.media,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((packForm.value.media) = $event)),
                    class: "col-span-full",
                    "max-files": 10
                  }, null, 8, ["previews", "modelValue"])
                ]))
              : (_openBlock(), _createBlock(_unref(Loader2), {
                  key: 1,
                  class: "w-10 h-10 animate-spin text-white mx-auto"
                })),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "text-white",
                  variant: "ghost",
                  onClick: closePackageDialog
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isSaving.value || !packForm.value.name || (!packForm.value.paymentPlanIds?.length) || !packForm.value.status || (!packForm.value.media?.length && !editingPackage.value),
                  onClick: save
                }, {
                  default: _withCtx(() => [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(editingPackage.value ? 'Salvar alterações' : 'Cadastrar pack'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})